var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { fontSize } from 'styled-system';
import { themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, } from '../../../common/theme/theme';
import themedComponent from '../../../common/components/hoc/themedComponent';
import wishlistIcon from '../../../common/assets/icons/h24/wishlist.svg';
import h24AccountIcon from '../../../common/assets/icons/h24/account.svg';
import h24CartIcon from '../../../common/assets/icons/h24/cart.svg';
import ffhAccountIcon from '../../../common/assets/icons/ffh/account.svg';
import ffhCartIcon from '../../../common/assets/icons/ffh/cart.svg';
var Icon = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), fontSize, themeWidth, themeMaxWidth, themeHeight, themeMaxHeight);
Icon.defaultProps = {
    alt: '',
    role: 'presentation',
    fontSize: 0,
    themeWidth: [5, '40px', 5],
    themeMaxWidth: [5, '40px', 5],
    themeHeight: [5, '40px', 5],
    themeMaxHeight: [5, '40px', 5],
};
export var Account = themedComponent(function () { return React.createElement(Icon, { src: h24AccountIcon }); }, function () { return React.createElement(Icon, { src: ffhAccountIcon }); });
export var Wishlist = function (props) { return React.createElement(Icon, __assign({ src: wishlistIcon }, props)); };
export var Cart = themedComponent(function () { return React.createElement(Icon, { src: h24CartIcon }); }, function () { return React.createElement(Icon, { src: ffhCartIcon }); });
var templateObject_1;
